import { render, staticRenderFns } from "./BrandList.vue?vue&type=template&id=f082a01e&scoped=true"
import script from "./BrandList.vue?vue&type=script&lang=js"
export * from "./BrandList.vue?vue&type=script&lang=js"
import style0 from "./BrandList.vue?vue&type=style&index=0&id=f082a01e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f082a01e",
  null
  
)

export default component.exports